module.exports = __webpack_public_path__ + "img/Pro-13.86c34830.jpg";